import type {PageRouteConfig} from '@router';

import Profile from 'modules/Profile/Profile';

export function createProfileRoute(): PageRouteConfig {
  return {
    element: <Profile />,
    layout: {
      title: 'حساب شما',
      hasNavigate: true,
      hasHeader: true,
      hasBack: false,
      link: -1,
      hasLeftIcon: false
    }
  };
}
